import React from 'react';
import { Path, G, Defs, LinearGradient, Stop, Rect } from 'react-native-svg';

export default {
  gradient: {
    svg: (
      <G>
        <Defs>
          <LinearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <Stop offset="0%" stopColor="#006ce6" />
            <Stop offset="100%" stopColor="#06c4fd" />
          </LinearGradient>
        </Defs>
        <Rect fill="url(#gradient)" x="0" y="0" width="100%" height="100%" />
      </G>
    ),
  },
  info: {
    svg: (
      <G fillRule="evenodd" stroke="none" strokeWidth="1">
        <G fillRule="nonzero" transform="translate(-20 -20)">
          <Path d="M120 75c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm0 30c5.523 0 10 4.477 10 10v40c0 5.523-4.477 10-10 10s-10-4.477-10-10v-40c0-5.523 4.477-10 10-10zm0-85C64.8 20 20 64.8 20 120s44.8 100 100 100 100-44.8 100-100S175.2 20 120 20zm0 180c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z" />
        </G>
      </G>
    ),
    viewBox: '0 0 200 200',
  },
  location: {
    svg: (
      <G fillRule="evenodd" stroke="none" strokeWidth="1">
        <G fillRule="nonzero" transform="translate(-50 -20)">
          <Path d="M120 20c-38.7 0-70 31.3-70 70 0 52.5 70 130 70 130s70-77.5 70-130c0-38.7-31.3-70-70-70zM70 90c0-27.6 22.4-50 50-50s50 22.4 50 50c0 28.8-28.8 71.9-50 98.8-20.8-26.7-50-70.3-50-98.8zm50-20c11.046 0 20 8.954 20 20s-8.954 20-20 20-20-8.954-20-20 8.954-20 20-20z" />
        </G>
      </G>
    ),
    viewBox: '0 0 140 200',
  },
  description: {
    svg: (
      <G fillRule="evenodd" stroke="none" strokeWidth="1">
        <Path
          d="M80 160h70c5.523 0 10 4.477 10 10s-4.477 10-10 10H90c-5.523 0-10-4.477-10-10v-10zm0-40h70c5.523 0 10 4.477 10 10s-4.477 10-10 10H90c-5.523 0-10-4.477-10-10v-10zm60-100H40v180c0 11 8.9 20 19.9 20H180c11 0 20-9 20-20V80l-60-60zm30 180H70c-5.523 0-10-4.477-10-10V40h70v40c0 5.523 4.477 10 10 10h40v100c0 5.523-4.477 10-10 10z"
          transform="translate(-40 -20)"
        />
      </G>
    ),
    viewBox: '0 0 160 200',
  },
  chair: {
    svg: (
      <G fillRule="evenodd" stroke="none" strokeWidth="1">
        <Path
          d="M43.957 25A20 20 0 0163.48 40.661l14.78 66.508A10 10 0 0088.022 115H160c10.93 0 19.813 8.769 19.997 19.656L180 135h-29.492l15.256 45.768.81-.57a80.317 80.317 0 0010.186-8.62l.722-.73c5.068-5.2 13.391-5.307 18.59-.239l4.244 4.242c-18.23 24.38-47.33 40.149-80.14 40.149-32.833 0-61.949-15.79-80.176-40.195l4.105-4.106c5.141-5.14 13.476-5.14 18.617 0l.123.125a80.309 80.309 0 0011.742 9.945L89.842 135h-9.735a20 20 0 01-19.54-15.737L40 25h3.957zm86.718 110h-21l-25.69 51.38c10.865 5.514 23.162 8.62 36.191 8.62 13.029 0 25.325-3.106 36.189-8.62L130.675 135z"
          transform="translate(-40 -25)"
        />
      </G>
    ),
    viewBox: '0 0 161 190',
  },
  settings: {
    svg: (
      <G fillRule="evenodd" stroke="none" strokeWidth="1">
        <Path
          d="M140 20c2.424 0 4.472 1.693 4.868 3.984l.032.216 3.8 26.5c5.81 2.381 11.166 5.488 16.154 9.233l.746.567 24.9-10c.5-.2 1.1-.3 1.7-.3 1.722 0 3.352.823 4.278 2.295l.122.205 20 34.6c1.161 2.129.73 4.726-1.02 6.251l-.18.149-21.1 16.5c.4 3.2.7 6.4.7 9.8 0 3.06-.243 5.958-.583 8.84l-.117.96 21.1 16.5c1.839 1.452 2.366 4.027 1.31 6.186l-.11.214-20 34.6c-.9 1.6-2.6 2.5-4.3 2.5-.5 0-1-.07-1.5-.208l-.3-.092-24.9-10c-4.952 3.714-10.268 6.975-16.032 9.437l-.868.363-3.8 26.5c-.29 2.327-2.274 4.09-4.674 4.195L140 220h-40c-2.424 0-4.472-1.693-4.868-3.984L91.3 189.3c-5.81-2.381-11.166-5.488-16.154-9.233l-.746-.567-24.9 10c-.5.2-1.1.3-1.7.3-1.722 0-3.352-.823-4.278-2.295l-.122-.205-20-34.6c-1.161-2.129-.73-4.726 1.02-6.251l.18-.149 21.1-16.5c-.4-3.2-.7-6.5-.7-9.8 0-2.933.237-5.867.57-8.73l.13-1.07-21.1-16.5c-1.84-1.453-2.461-4.032-1.316-6.192l.116-.208 20-34.6c.9-1.6 2.6-2.5 4.3-2.5.5 0 1 .07 1.5.208l.3.092 24.9 10c4.952-3.714 10.268-6.975 16.032-9.437l.868-.363 3.8-26.5c.29-2.327 2.274-4.09 4.674-4.195L100 20h40zm-13.1 20H113l-2 13.5-1.6 11.3-10.6 4.3c-3.884 1.61-7.768 3.85-11.823 6.801l-.677.499-9 6.8L66.9 79l-12.7-5.1-7 12.1L58 94.4l8.9 7-1.4 11.3-.158 1.616c-.21 2.236-.342 4.059-.342 5.684 0 1.765.156 3.763.398 6.338l.102 1.062 1.4 11.3-8.9 7-10.8 8.4 7 12.1 12.7-5.1 10.6-4.3 9.1 7c3.765 2.824 7.53 5.027 11.544 6.777l.756.323 10.6 4.3 1.6 11.3L113 200h14l2-13.5 1.6-11.3 10.6-4.3c3.884-1.61 7.768-3.85 11.823-6.801l.677-.499 9-6.8 10.4 4.2 12.7 5.1 7-12.1-10.8-8.4-8.9-7 1.4-11.3.158-1.608c.21-2.213.342-3.986.342-5.692l-.004-.743a51.81 51.81 0 00-.367-5.503l-.129-1.054-1.4-11.3 8.9-7 10.7-8.5-7-12.1-12.7 5.1-10.6 4.3-9.1-7c-3.765-2.824-7.53-5.027-11.544-6.777L141 69.1l-10.6-4.3-1.6-11.3-1.9-13.5zM120 80c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 20c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20z"
          transform="translate(-22 -20)"
        />
      </G>
    ),
    viewBox: '0 0 196 200',
  },
  percentage: {
    svg: (
      <G fillRule="evenodd" stroke="none" strokeWidth="1">
        <G fillRule="nonzero" transform="translate(-45 -42)">
          <Path d="M175 145c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30 0-16.569 13.431-30 30-30zm18.514-102.156l7.071 7.071c3.905 3.905 3.905 10.237 0 14.142l-134.35 134.35c-3.905 3.906-10.237 3.906-14.142 0-3.906-3.905-3.906-10.237 0-14.142L193.514 42.844zM175 165c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zM75 45c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30 0-16.569 13.431-30 30-30zm0 20c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10z" />
        </G>
      </G>
    ),
    viewBox: '0 0 160 163',
  },
  close: {
    svg: (
      <G fillRule="evenodd" stroke="none" strokeWidth="1">
        <G fillRule="nonzero" transform="translate(-50 -50)">
          <Path d="M182.929 57.029L175.9 50 120 105.9 71.171 57.071c-3.905-3.905-10.237-3.905-14.142 0L50 64.1l55.9 55.9-48.829 48.829c-3.905 3.905-3.905 10.237 0 14.142L64.1 190l55.9-55.9 48.829 48.829c3.905 3.905 10.237 3.905 14.142 0L190 175.9 134.1 120l48.829-48.829c3.905-3.905 3.905-10.237 0-14.142z" />
        </G>
      </G>
    ),
    viewBox: '0 0 140 140',
  },
  arrowLeft: {
    svg: (
      <G fillRule="evenodd" stroke="none" strokeWidth="1">
        <G fillRule="nonzero" transform="translate(-58 -21)">
          <Path d="M160.878 24.558L157.3 21l-98.9 99 99 99 3.558-3.558c7.81-7.81 7.81-20.474 0-28.284L93.8 120l67.118-67.118c7.81-7.81 7.81-20.474 0-28.284a19.818 19.818 0 00-.04-.04z" />
        </G>
      </G>
    ),
    viewBox: '0 0 109 198',
  },
  arrowLeftSmall: {
    svg: (
      <G fillRule="evenodd" stroke="none" strokeWidth="1">
        <G fillRule="nonzero" transform="translate(-80 -60)">
          <Path d="M140.015 151.785L108.3 120l31.715-31.785C147.797 80.417 147.79 67.79 140 60l-60 60 60 60c7.79-7.79 7.797-20.417.015-28.215z" />
        </G>
      </G>
    ),
    viewBox: '0 0 66 120',
  },
  arrowRight: {
    svg: (
      <G fillRule="evenodd" stroke="none" strokeWidth="1">
        <G fillRule="nonzero" transform="translate(-73 -21)">
          <Path d="M82.6 219l99-99-99-99-3.558 3.558c-7.81 7.81-7.81 20.474 0 28.284L146.2 120l-67.158 67.158c-7.81 7.81-7.81 20.474 0 28.284L82.6 219z" />
        </G>
      </G>
    ),
    viewBox: '0 0 109 198',
  },
  arrowRightSmall: {
    svg: (
      <G fillRule="evenodd" stroke="none" strokeWidth="1">
        <G fillRule="nonzero" transform="translate(-94 -60)">
          <Path d="M99.985 151.785L131.7 120 99.985 88.215C92.203 80.417 92.21 67.79 100 60l60 60-60 60c-7.79-7.79-7.797-20.417-.015-28.215z" />
        </G>
      </G>
    ),
    viewBox: '0 0 66 120',
  },
  moneyPig: {
    svg: (
      <G fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <G fillRule="nonzero">
          <G transform="translate(20 55)">
            <Path d="M150 0v31.715l14.27 13.046A20 20 0 00177.764 50H200v47.64a20 20 0 01-11.056 17.888L180 120l-24.805 57.878A20 20 0 01136.812 190H110l-7.236-14.472A10 10 0 0093.82 170h-7.64a10 10 0 00-8.944 5.528L70 190H42.333a20 20 0 01-18.015-11.312C8.106 145.072 0 115.51 0 90c0-25.058 7.821-46.205 23.464-63.441A20 20 0 0138.274 20H100l14.142-14.142a20 20 0 0113.7-5.853l.442-.005H150zm-20 20l-21.716 20H48.031a20 20 0 00-16.44 8.609 38.08 38.08 0 00-1 1.513C23.508 61.472 20 74.618 20 90c0 19.454 5.648 42.429 17.178 68.796l.671 1.523c.45 1.008 1.04 2.302 1.772 3.882A10 10 0 0048.696 170h8.943l4.472-8.945A20 20 0 0180 150h20a20 20 0 0117.888 11.056L122.36 170h7.858a10 10 0 009.191-6.06l25.094-58.552 9.969-4.985a10 10 0 005.527-8.944V70h-13.881a10 10 0 01-6.748-2.62L130 40.53V20zm0 40c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.5-10 10-10zM90 50c5.523 0 10 4.477 10 10 0 5.43-4.327 9.848-9.72 9.996L90 70H60c-5.523 0-10-4.477-10-10 0-5.43 4.327-9.848 9.72-9.996L60 50h30z" />
          </G>
          <Path d="M95 2c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30C65 15.431 78.431 2 95 2zm0 20c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10z" />
        </G>
      </G>
    ),
    viewBox: '0 0 240 270',
  },
  pig: {
    svg: (
      <G fillRule="evenodd" stroke="none" strokeWidth="1">
        <G fillRule="nonzero" transform="translate(-20 -25)">
          <Path d="M170 25v31.715l14.27 13.046A20 20 0 00197.764 75H220v47.64a20 20 0 01-11.056 17.888L200 145l-24.805 57.878A20 20 0 01156.812 215H130l-7.236-14.472A10 10 0 00113.82 195h-7.64a10 10 0 00-8.944 5.528L90 215H62.333a20 20 0 01-18.015-11.312C28.106 170.072 20 140.51 20 115c0-25.058 7.821-46.205 23.464-63.441A20 20 0 0158.274 45H120l14.142-14.142a20 20 0 0113.7-5.853l.442-.005H170zm-20 20l-21.716 20H68.031a20 20 0 00-16.44 8.609 38.08 38.08 0 00-1 1.513C43.508 86.472 40 99.618 40 115c0 19.454 5.648 42.429 17.178 68.796l.671 1.523c.45 1.008 1.04 2.302 1.772 3.882A10 10 0 0068.696 195h8.943l4.472-8.945A20 20 0 01100 175h20a20 20 0 0117.888 11.056L142.36 195h7.858a10 10 0 009.191-6.06l25.094-58.552 9.969-4.985a10 10 0 005.527-8.944V95h-13.881a10 10 0 01-6.748-2.62L150 65.53V45zm0 40c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.5-10 10-10zm-40-10c5.523 0 10 4.477 10 10 0 5.43-4.327 9.848-9.72 9.996L110 95H80c-5.523 0-10-4.477-10-10 0-5.43 4.327-9.848 9.72-9.996L80 75h30z" />
        </G>
      </G>
    ),
    viewBox: '0 0 200 190',
  },
  crossedPig: {
    svg: (
      <G fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <G fillRule="nonzero" transform="translate(19.653 37)">
          <Path d="M150.347 0v31.715l14.27 13.046A20 20 0 00178.11 50h22.236v47.64a20 20 0 01-11.056 17.888L180.347 120l-24.805 57.878A20 20 0 01137.159 190h-26.812l-7.236-14.472A10 10 0 0094.166 170h-7.639a10 10 0 00-8.944 5.528L70.347 190H42.679a20 20 0 01-18.014-11.312C8.453 145.072.347 115.51.347 90c0-25.058 7.821-46.205 23.464-63.441A20 20 0 0138.621 20h61.726l14.142-14.142a20 20 0 0113.7-5.853l.442-.005h21.716zm-20 20L108.63 40H48.378a20 20 0 00-16.44 8.609 38.08 38.08 0 00-1 1.513C23.855 61.472 20.347 74.618 20.347 90c0 19.454 5.648 42.429 17.177 68.796l.672 1.523c.45 1.008 1.04 2.302 1.772 3.882A10 10 0 0049.043 170h8.943l4.472-8.945A20 20 0 0180.347 150h20a20 20 0 0117.888 11.056l4.472 8.944h7.858a10 10 0 009.191-6.06l25.094-58.552 9.968-4.985a10 10 0 005.528-8.944V70h-13.882a10 10 0 01-6.747-2.62l-29.37-26.851V20zm0 40c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.5-10 10-10zM16.87 6.387l.201.195L62.578 50h27.769c5.523 0 10 4.477 10 10 0 5.43-4.327 9.848-9.72 9.996l-.28.004H83.54l107.807 102.858c3.905 3.905 3.905 10.237 0 14.142-3.84 3.84-10.023 3.904-13.942.195l-.2-.195L2.929 20.724c-3.905-3.905-3.905-10.237 0-14.142 3.839-3.839 10.023-3.904 13.941-.195z" />
        </G>
      </G>
    ),
    viewBox: '0 0 240 270',
  },
  edit: {
    svg: (
      <G fillRule="evenodd" stroke="none" strokeWidth="1">
        <Path
          d="M132.84 64.733l42.427 42.426L72.463 209.963 30 210l.037-42.463L132.84 64.733zm0 28.283l-82.81 82.811-.012 14.156 14.153-.013 82.811-82.812-14.142-14.142zM175.284 22l28.285 28.284c7.81 7.81 7.81 20.474 0 28.285L189.426 92.71 147 50.284 175.284 22z"
          transform="translate(-30 -22)"
        />
      </G>
    ),
    viewBox: '0 0 180 188',
  },
  children: {
    svg: (
      <G>
        <Path
          d="M284.275,176.745c5.099-3.41,6.468-10.308,3.058-15.405l-38.876-58.124c-5.15-7.695-13.022-11.707-21.287-11.707h-16.658
		c-9.588,0-17.229,5.802-22.101,13.327c-0.487,0.753,2.422-3.679-37.983,56.486c-3.42,5.092-2.063,11.991,3.028,15.411
		c5.089,3.418,11.99,2.065,15.411-3.028l16.656-24.802l0.034,112.663c0,7.667,6.215,13.882,13.882,13.882
		c7.667,0,13.882-6.215,13.882-13.882v-62.471h11.107v62.471c0,7.667,6.215,13.882,13.882,13.882
		c7.667,0,13.882-6.215,13.882-13.882c0-119.736-0.033-111.963-0.033-112.865l16.712,24.986
		C272.285,178.793,279.188,180.15,284.275,176.745z"
        />
        <Path
          d="M218.874,80.75c14.696,0,26.615-11.908,26.615-26.614c0-9.582-5.076-17.983-12.686-22.668
		c1.573-1.112,3.405-2.139,5.57-3.017c0.909-0.368,1.521-1.231,1.567-2.211c0.047-0.981-0.481-1.897-1.352-2.35
		c-4.209-2.186-9.338-2.231-14.178-1.303c0.821-1.538,1.855-3.109,3.183-4.702c0.628-0.754,0.761-1.804,0.34-2.689
		c-0.421-0.886-1.318-1.446-2.3-1.436c-9.728,0.111-18.649,9.972-22.203,15.869c-0.826,1.37-1.446,2.821-1.837,4.284
		c-5.71,4.881-9.335,12.129-9.335,20.223C192.259,68.842,204.178,80.75,218.874,80.75z"
        />
        <Path
          d="M100.382,104.202C95.588,96.932,87.96,91.509,78.63,91.509H61.971c-9.491,0-17.747,5.292-21.977,13.086
		c-0.514,0.74-37.605,55.979-38.107,56.728c-3.42,5.092-2.063,11.991,3.028,15.411c5.089,3.418,11.99,2.065,15.411-3.028
		l16.656-24.802v0.307l-15.118,61.638c-0.706,2.875-0.051,5.915,1.776,8.244c1.828,2.33,4.624,3.69,7.585,3.69h5.791v38.784
		c0,7.667,6.215,13.882,13.882,13.882s13.882-6.215,13.882-13.882v-38.784h11.106v38.784c0,7.667,6.215,13.882,13.882,13.882
		c7.667,0,13.882-6.215,13.882-13.882v-38.784h5.726c2.961,0,5.757-1.36,7.585-3.69c1.827-2.329,2.482-5.369,1.776-8.244
		l-15.119-61.642h-0.001v-0.403l16.724,24.902c3.421,5.094,10.323,6.445,15.411,3.028c5.092-3.42,6.448-10.319,3.028-15.411
		C97.759,100.238,100.862,104.931,100.382,104.202z"
        />
        <Path
          d="M17.233,88.896c0.978,0.081,1.912-0.414,2.396-1.268c7.311-12.904,18.78-11.81,21.349-16.575
		c0.354-0.658,0.633-1.336,0.839-2.025c0.783,0.844,1.885,1.34,3.044,1.34c0.458,0,0.925-0.076,1.381-0.237
		c0.77-0.271,1.401-0.751,1.873-1.347c4.763,7.21,12.935,11.967,22.221,11.967c9.285,0,17.458-4.757,22.22-11.967
		c0.472,0.596,1.103,1.076,1.874,1.347c0.457,0.161,0.923,0.237,1.381,0.237c1.159,0,2.261-0.496,3.044-1.34
		c0.206,0.689,0.484,1.367,0.839,2.025c2.568,4.765,14.037,3.671,21.348,16.575c0.483,0.854,1.418,1.349,2.396,1.268
		c0.979-0.081,1.819-0.724,2.155-1.646c3.329-9.14-2.747-20.968-7.012-26.376c-3.668-4.653-9.315-7.166-14.532-4.355
		c-0.186,0.1-0.357,0.215-0.534,0.323l0.043-0.122c0.763-2.17-0.378-4.547-2.548-5.31c-1.479-0.521-3.04-0.143-4.134,0.827
		c-0.976-13.8-12.483-24.706-26.539-24.706c-14.058,0-25.565,10.907-26.54,24.707c-1.096-0.97-2.658-1.348-4.134-0.828
		c-2.17,0.763-3.311,3.14-2.548,5.31l0.043,0.122c-0.177-0.109-0.349-0.224-0.533-0.323c-5.217-2.811-10.864-0.299-14.533,4.355
		c-4.265,5.408-10.341,17.236-7.012,26.376C15.414,88.172,16.255,88.815,17.233,88.896z"
        />
      </G>
    ),
    viewBox: '0 0 289.207 289.207',
  },
  delete: {
    svg: (
      <G>
        <Path
          d="M1 5H3M3 5H19M3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V5M6 5V3C6 2.46957 6.21071 1.96086 6.58579 1.58579C6.96086 1.21071 7.46957 1 8 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V5M8 10V16M12 10V16"
          stroke="#464543"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
      </G>
    ),
    viewBox: '0 0 20 22',
  },
  house: {
    svg: (
      <G>
        <Path
          d="M50.6158 30.5479V61.9999H16.8984V30.5479"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <Path
          d="M62.3685 61.9998H50.6172V58.3327C50.6172 55.0876 53.2478 52.457 56.4928 52.457H56.4929C59.7379 52.457 62.3685 55.0876 62.3685 58.3327V61.9998Z"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <Path
          d="M9.44917 50.3545H9.44919C13.5605 50.3545 16.8984 53.6924 16.8984 57.8037V62H2V57.8037C2 53.6924 5.33786 50.3545 9.44917 50.3545Z"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <Path
          d="M55.6436 35.6705L33.7593 13.3506L11.875 35.6705"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <Path
          d="M40.8816 38.6064H26.6367V61.9995H40.8816V38.6064Z"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <Path
          d="M33.7566 32.1664C35.9672 32.1664 37.7592 30.3744 37.7592 28.1638C37.7592 25.9532 35.9672 24.1611 33.7566 24.1611C31.546 24.1611 29.7539 25.9532 29.7539 28.1638C29.7539 30.3744 31.546 32.1664 33.7566 32.1664Z"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <Path
          d="M15.6679 9.78901C17.8188 9.78901 19.5624 8.04538 19.5624 5.89451C19.5624 3.74363 17.8188 2 15.6679 2C13.5171 2 11.7734 3.74363 11.7734 5.89451C11.7734 8.04538 13.5171 9.78901 15.6679 9.78901Z"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <Path
          d="M2.35156 19.2106L12.9138 8.64844"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <Path
          d="M7.23438 14.3271L9.27588 16.3687"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <Path
          d="M4.8125 16.75L8.43131 20.3688"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
      </G>
    ),
    viewBox: '0 0 64 64',
  },
  graph: {
    svg: (
      <G>
        <Path
          d="M2 2V62H62"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <Path
          d="M16.3497 42.0273H7.77344V61.9998H16.3497V42.0273Z"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <Path
          d="M30.2814 31.7324H21.7051V61.9999H30.2814V31.7324Z"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <Path
          d="M44.212 19.25H35.6357V62.0011H44.212V19.25Z"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <Path
          d="M58.1427 2.36914H49.5664V62.0005H58.1427V2.36914Z"
          stroke="#54A8D1"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
      </G>
    ),
    viewBox: '0 0 64 64',
  },
  savings_v2: {
    svg: (
      <Path d="M140 170v19.999c0 3.197-1.271 6.043-3.25 7.874a2.54 2.54 0 01-.118.115c-7.601 6.858-25.11 11.717-45.183 12.003l-1.71.009-.572-.001c-20.308-.193-38.07-5.068-45.767-11.982l-.176-.169c-1.964-1.831-3.224-4.667-3.224-7.85V170l.004.326c.08 2.94 1.237 5.56 3.019 7.329l.377.362c7.62 6.844 25.101 11.69 45.152 11.974l.615.008c.832.002 1.387.002 1.666 0 20.33-.195 38.12-5.083 45.799-12.011.04-.036.08-.074.118-.115 1.91-1.768 3.161-4.482 3.245-7.545L140 170zm0-39.999v20c0 3.197-1.271 6.043-3.25 7.874a2.54 2.54 0 01-.118.115c-7.601 6.858-25.11 11.717-45.183 12.003l-1.71.009-.572-.001c-20.308-.193-38.07-5.068-45.767-11.982l-.176-.169C41.26 156.019 40 153.183 40 150v-19.999l.004.327c.08 2.94 1.237 5.56 3.019 7.329l.377.362c7.62 6.844 25.101 11.69 45.152 11.974l.615.008c.832.002 1.387.002 1.666 0 20.33-.195 38.12-5.083 45.799-12.011.04-.036.08-.074.118-.115 1.91-1.768 3.161-4.482 3.245-7.545l.005-.329zM200 110v20c0 3.198-1.271 6.044-3.25 7.875a2.54 2.54 0 01-.118.115c-6.498 5.863-20.238 10.265-36.631 11.598v-20c16.393-1.333 30.133-5.735 36.63-11.598.04-.036.08-.074.119-.115 1.91-1.768 3.161-4.482 3.245-7.545L200 110zM90.833 90c20.591.102 38.044 5.014 45.799 12.01.04.037.08.075.118.116 1.91 1.767 3.161 4.482 3.245 7.545L140 110c0 3.197-1.271 6.044-3.25 7.874a2.14 2.14 0 01-.118.116c-7.593 6.85-25.074 11.707-45.122 12.002l-1.877.01-.466-.002-1.35-.02c-19.742-.39-36.891-5.2-44.417-11.96l-.176-.17C41.26 116.018 40 113.183 40 110l.004-.328c.08-2.94 1.237-5.56 3.019-7.328l.377-.363C51.175 94.997 68.592 90.097 89.167 90h1.666zM200 70.001v20c0 3.197-1.271 6.043-3.25 7.874a2.54 2.54 0 01-.118.115c-6.498 5.863-20.238 10.265-36.631 11.598L160 89.863l-.003-.275c16.395-1.332 30.136-5.734 36.635-11.598.04-.036.08-.074.118-.115 1.91-1.768 3.161-4.482 3.245-7.545l.005-.329zM150.833 30c20.591.102 38.044 5.014 45.799 12.01.04.037.08.075.118.116 1.91 1.767 3.161 4.482 3.245 7.545L200 50c0 3.197-1.271 6.044-3.25 7.874a2.14 2.14 0 01-.118.116c-7.593 6.85-25.074 11.707-45.122 12.002l-1.877.01-.466-.002-1.35-.02c-19.742-.39-36.891-5.2-44.417-11.96l-.176-.17C101.26 56.018 100 53.183 100 50l.004-.328c.08-2.94 1.237-5.56 3.019-7.328l.377-.363c7.775-6.984 25.192-11.884 45.767-11.981h1.666z" />
    ),
    viewBox: '0 0 240 240',
  },
};
